import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { handleTabDelimitedText } from '@src/routes/Configurators/utils/TabDelimitedData'
import { Grid } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  textarea: {
    '& textarea': {
      overflow: 'auto',
    },
  },
  textBorder: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 5,
    resize: 'none',
    width: '100%',
  },
}))
const CopyEntry = (props) => {
  const classes = useStyles()

  return (
    <Grid container>
      <Grid item xs={12}>
        <textarea
          className={classes.textBorder}
          name="copyPasteText"
          rows={7}
          onKeyDown={(e) => {
            if (e.key === 'Tab') {
              const event = handleTabDelimitedText(e)
              props.handlechange(event)
            }
          }}
          value={props.text}
          onChange={(e) => props.handlechange(e)}
        />
      </Grid>
    </Grid>
  )
}
export default CopyEntry
